import { httpClient } from '../client';
import { logger } from '../../../utils/logger';
import { BaseEndpoint } from './base.endpoint';
import { ApiErrorHandler } from '../error.handler';
import { SmsSettings, SmsSettingsApiResponse } from '../../../types/sms-settings';

class SmsSettingsEndpoints extends BaseEndpoint {
  private static instance: SmsSettingsEndpoints;

  private constructor() {
    super('organisations');
  }

  static getInstance(): SmsSettingsEndpoints {
    if (!SmsSettingsEndpoints.instance) {
      SmsSettingsEndpoints.instance = new SmsSettingsEndpoints();
    }
    return SmsSettingsEndpoints.instance;
  }

  async getSmsSettings(organizationId: string) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.get<SmsSettingsApiResponse>(
        `${this.basePath}/${organizationId}/sms-settings`,
        { headers }
      );

      logger.info('SMS settings fetched successfully');
      const data = response.data.data;
      return data;
    } catch (error) {
      logger.error('Failed to fetch SMS settings:', error);

      return ApiErrorHandler.handle(error);
    }
  }

  async createSmsSettings(organizationId: string, smsSettings: SmsSettings) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.post<SmsSettings>(
        `${this.basePath}/${organizationId}/sms-settings`,
        smsSettings,
        { headers }
      );

      logger.info('SMS settings created successfully');
      return response.data;
    } catch (error) {
      logger.error('Failed to create SMS settings:', error);

      return ApiErrorHandler.handle(error);
    }
  }

  async updateSmsSettings(organizationId: string, smsSettings: SmsSettings) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.put<SmsSettings>(
        `${this.basePath}/${organizationId}/sms-settings`,
        smsSettings,
        { headers }
      );

      logger.info('SMS settings updated successfully');
      return response.data;
    } catch (error) {
      logger.error('Failed to update SMS settings:', error);
      return ApiErrorHandler.handle(error);
    }
  }

  async deleteSmsSettings(organizationId: string) {
    try {
      const headers = await this.getAuthHeaders();
      await httpClient.delete(`${this.basePath}/${organizationId}/sms-settings`, {
        headers,
      });

      logger.info('SMS settings deleted successfully');
    } catch (error) {
      logger.error('Failed to delete SMS settings:', error);

      return ApiErrorHandler.handle(error);
    }
  }
}

export const smsSettingsEndpoints = SmsSettingsEndpoints.getInstance();
